// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainHome_mainWrapper__I5m3C","eachCardWrapper":"MainHome_eachCardWrapper__y+Da+"};